<script lang="ts">
    import type { ProjectDetailsData } from "../../api/projects/data/projects/ProjectDetailsData";
    import {appManager} from "../../AppManager";
    import { ModalHook } from "../../shared/modals/ModalHook";
    import { _ } from "svelte-i18n";
    
    let hook = new ModalHook<ProjectDetailsData, boolean>();
    appManager.ModalHooks.ProjectDeleteConfirmModal = hook;
    let open: boolean = false;
    let data: ProjectDetailsData;

    let safety = ""
    let safetyPassed: boolean = false

    $: {
        safetyPassed = safety.toLowerCase().trim() === data?.name?.toLowerCase()?.trim()
    }

    
    // hook events.
    hook.on("open", () => {
        open = true;

        data = hook.getData();
    });
    hook.on("close", () => {
        open = false;
    });
    
    const ok = () => {
        hook.close(true);
    };

    const close = () => {
        hook.close(false);
    };
</script>

{#if open}
    <div
            class="modal show" style="display: block;"
            tabindex="-1"
            role="dialog"
            aria-labelledby="Label"
            aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-body p-6">
                    <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            on:click={close}/>

                    <h4 class="font-weight-bold text-center mb-3">
                        {$_("impact.project.deleteModal.areYouSure")}
                    </h4>

                    {#if typeof data !== "undefined"}
                        <p
                                class="font-size-lg bold text-center mb-6 mb-md-8">
                            {data.name}
                        </p>

                        <p
                                class="font-size-lg text-center text-muted mb-6 mb-md-8">
                            {@html data.description}
                        </p>
                    {/if}
                    <div>
                        {$_("impact.project.deleteModal.scenariosToo")}
                        {$_("impact.project.deleteModal.noUndo")}
                    </div>
                    <div>{$_("impact.project.deleteModal.safetyQuestion", { values: { name: data.name } })}</div>

                    <input bind:value={safety} class="w-100">


                    <div class="row">
                        <div class="col-6">
                            <div class="d-grid gap-2">
                                {#if safetyPassed}
                                    <button
                                            class="btn btn-block btn-danger mt-3 lift"
                                            on:click={ok}>
                                        <span class="fe fe-trash-2"></span>
                                        {$_("impact.project.deleteModal.delete")}
                                    </button>
                                {:else}
                                    <span class="btn">
                                        {$_("impact.project.deleteModal.answerFirst")}
                                    </span>
                                {/if}
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="d-grid gap-2">
                                <button
                                        class="btn btn-block btn-secondary-soft mt-3 lift"
                                        on:click={close}>
                                    {$_("impact.project.deleteModal.cancel")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/if}
